module.exports = __webpack_public_path__ + "static/t1-9b89e8d0c204868af1d5c7800041f5b6.svg";